export default {
  MyClass: require('./myClass/MyClass').default,
  DetailClass: require('./detailClass/DetailClass').default,
  DetailClassV2: require('./detailClassV2/DetailClassV2').default,
}